import { parseTime } from '../../utils/time';

export const validateTime = (value?: string) => {
  if (!value) return false;
  const date = parseTime(value);
  return date?.isValid();
};
